
import './notify.sass'

export default {
  install(Vue, options) {

    // vue-toasted
    if(global.Toasted) {
      Vue.use(global.Toasted, {
        duration: 5000,
        keepOnHover: true,
        containerClass: 'vue-toasted-ex',
      })

      const notify   = text => {Vue.toasted.show(text)}
      notify.show    = text => {Vue.toasted.show(text)}
      notify.info    = text => {Vue.toasted.info(text)}
      notify.warn    = text => {Vue.toasted.error(text)}
      notify.error   = text => {Vue.toasted.error(text)}
      notify.success = text => {Vue.toasted.success(text)}
      Vue.prototype.$cnmn = {...Vue.prototype.$cnmn, notify}
      Vue.cnmn = {...Vue.cnmn, notify}
      return
    }

    // fallback
    const notify   = () => {}
    notify.show    = () => {}
    notify.info    = () => {}
    notify.warn    = () => {}
    notify.error   = () => {}
    notify.success = () => {}
    Vue.prototype.$cnmn = {...Vue.prototype.$cnmn, notify}
    Vue.cnmn = {...Vue.cnmn, notify}
  }
}
